<template>   
<div>     <header class="header">       
<div class="container" :class="[containerClass, filterClass, {'transparent-header': $route.meta.isFullScreen}]">         
<div class="container-limit">           <ul class="fljs" :class="isHome && ScrollTop < videoHeight ? 'home-ul' : ''" style="justify-content: normal">             
<div class="logo" @click="showBlogDetail">               <img class="circle" :src="isHome && ScrollTop < videoHeight ? toolbar.topLogo : toolbar.topWhiteLogo" alt="" />             
</div>             <li               v-for="item in navList"               :key="item.value"               :style="itemStyle(item)"               :class="[item.menuId === selected ? 'selected' : '', item.path === 'Index' ? '' : showIcon]"               class="menu"               @click="handleClickHome(item)"               @mouseenter="item.show = true"               @mouseleave="item.show = false"             >               {{ item.menuName }}               
<div class="menu-item" v-if="item.value !== 'Index' && item.show && item.children">                 
<div v-for="child in item.children" :key="child.menuId" @click.stop="handleClick(child)" style="padding: 0 40px">{{ child.menuName }}
</div>               
</div>             </li>           </ul>           
<div class="search">             
<el-dropdown  v-if="lists.length > 1 && userInfo.extras && userInfo.extras.hasCollege" @command="handleCommandCollege" trigger="click" placement="bottom-start">               <span class="el-dropdown-link">                 <span class="college-name">{{ collegeName }}</span>                 <i class="el-icon-arrow-down el-icon--right"></i>               </span>               
<el-dropdown-menu slot="dropdown" class="collage-dropdown">                 
<el-dropdown-item v-for="college in lists" :key="college.id" :command="college.id" :class="{'collage-dropdown-menu__item':getCollegeId==college.id}">                   
<div class="collage-dropdown-menu__collegename">{{college.name}}
</div>                 <i v-if="getCollegeId==college.id" class="el-icon-check"></i>                 
</el-dropdown-item>               
</el-dropdown-menu>             
</el-dropdown>             <!-- 
<el-button autoId="btn_goDownload" class="down-btn" :class="[isHome && !showCover && ScrollTop < videoHeight ? 'home-btn' : '']" type="text" @click="goDownload">               <i class="el-icon-download" />               客户端下载              
</el-button> -->             <i class="search-icon" :class="[isHome && !showCover && ScrollTop < videoHeight ? 'home-icon' : '']" @mouseover="showSearchCover(true)" @mouseout="showSearchCover(false)" />             <span class="notice-box" @click="jumpMessage">               <!-- TODO -->               <i class="iconfont icon-belll icon-top-notice" :class="[isHome && !showCover && ScrollTop < videoHeight ? 'notice-icon' : '']"  />               <span v-if="this.$store.state.message.unreadMessageCount > 0" class="count">{{ this.$store.state.message.unreadMessageCount > 99 ? '99+' : this.$store.state.message.unreadMessageCount }}</span>             </span>             
<div v-if="!userInfo.id" class="login-btns" :class="{ 'home-btns': isHome && !showCover && ScrollTop < videoHeight }">               <span @click="openLogin">登录 </span>               |               <span @click="openLogin">注册</span>             
</div>             <!-- 
<div class="isLogin" v-else @click="goToMy">             <img :src="userInfo.avatar" alt="" />             <span>{{ userInfo.phonenumber }} <i class="el-icon-arrow-down"></i></span>           
</div> -->             
<el-dropdown class="dropdown" v-else @command="handleCommand">               
<div class="isLogin">                 <img :src="userInfo.avatar ? userInfo.avatar : require('@/assets/images/avatar.svg')" alt="" style="object-fit: cover" />                 <span class="login-name">{{ userInfo.realName }} <i class="el-icon-arrow-down" style="margin-right: -5px"></i></span>               
</div>               
<el-dropdown-menu slot="dropdown">                 
<el-dropdown-item command="goToMy">个人中心
</el-dropdown-item>                 
<el-dropdown-item command="handelLogout">退出登录
</el-dropdown-item>               
</el-dropdown-menu>             
</el-dropdown>           
</div>         
</div>       
</div>       
<div class="sarch-cover" v-if="showCover" @mouseover="showSearchCover(true)" @mouseout="showSearchCover(false)">         
<div class="search">           <!-- <input v-model="searchVal" placeholder="请输入搜索内容" @keydown.enter="goSearch('0')" />         <i @click="goSearch('0')" /> -->           
<el-input autoId="input_searchVal"             placeholder="请输入搜索内容"             v-model="searchVal"             class="input-with-select"             @keyup.enter.native="goSearch('0')"             v-on:mouseover.native="showSearchIcon = false"             v-on:mouseleave.native="showSearchIcon = true"           >             <i slot="suffix" class="el-input__icon el-icon-search" @click="goSearch('0')" style="right: 1px; top: 6px"></i>             <i slot="suffix" class="el-input__icon el-icon-circle-close el-input__clear" @click="searchVal = undefined" v-if="!showSearchIcon && searchVal" style="right: 40px; top: 1px"></i>            
</el-input>           <label class="senior-search" @click="goSearch('1')">高级搜索</label>           <!-- 
<div class="condition">             <label>条件检索:</label>             <ul>               <li v-for="item in browseWith" :key="item.key" @click="goToKeySearch(item)">                 {{ item.label }}               </li>             </ul>           
</div> -->         
</div>       
</div>       <Login ref="login" />     </header>     
<div v-if="!$route.meta.isFullScreen" style="width: 100%; height: 64px">
</div>     <!-- 
<el-dialog       title="切换院校"       custom-class="customer public-dialog-class"       :visible.sync="dialogVisible"       width="500px"     >       <span class="title">当前院校：{{ collegeName }}</span>       
<div class="dialog-form">         
<el-form           :model="ruleForm"           :rules="rules"           ref="ruleForm"           label-width="0px"           class="demo-ruleForm"         >           
<el-form-item prop="collegeId">             
<el-select autoId="select_ruleForm_collegeId"               v-model="ruleForm.collegeId"               placeholder="请选择"               clearable               filterable               style="width: 100%"             >                
<el-option                 v-for="college in lists"                 :key="college.id"                 :value="college.id"                 :label="college.name"               >
</el-option>             
</el-select>           
</el-form-item>         
</el-form>       
</div>       <span slot="footer" class="dialog-footer">         
<el-button autoId="btn_cancel" @click="cancel">取 消 
</el-button>         
<el-button autoId="btn_switchCollege" type="primary" @click="switchCollege">确 定 
</el-button>       </span>     
</el-dialog> -->   
</div> </template>

<script>
import Login from '../../views/login/index.vue'
import { getNavMenu } from '@/api/home'
import { mapGetters } from "vuex";
import { saveCollege } from "@/api/login";
import { debounce } from "@/utils";
import { EventBus } from '@/utils/eventBus'
export default {
  name: 'topHeader',
  components: { Login },
  data() {
    return {
      videoHeight: 680,
      minHeight: window.innerHeight - 305,
      selected: 'index',
      searchVal: '',
      list: [],
      zhutiseimgurl: require('../../assets/images/temp/nav_logo.png'),
      showSearchIcon: true,
      browseWith: [
        {
          key: '1',
          name: 'subject',
          label: '学科'
        },
        /*
        {
          key: '2',
          name: 'publisher',
          label: '出版社'
        },
         */
        // {
        //   key: '3',
        //   name: 'hierarchical',
        //   label: '层次'
        // },
        {
          key: '4',
          name: 'collections',
          label: '集合'
        }
      ],
      isHome: this.$route.name === 'Index',
      showCover: false,
      timer: null,
      ScrollTop: 0,
      ScrollLeft: 0,
      scrollLine: 0,
      ruleForm: {
        collegeId: "",
      },
      rules: {},
      dialogVisible: false,
    }
  },
  computed: {
    navList() {
      return this.token ? this.list : this.list.filter(it => it.menuId !== 'list')
    },
    containerClass() {
      return this.isHome && !this.showCover && this.ScrollTop < this.videoHeight
        ? 'container-home'
        : null;
    },
    filterClass() {
      return this.ScrollTop > 30 ? 'isFilter' : '';
    },
    showIcon() {
      return !this.showCover && this.$route.name === 'Index' ? 'arrowdown-home' : 'arrowdown'
    },
    userInfo() {
      return this.$store.state.user.userInfo || {}
    },
    toolbar() {
      return this.$store.state.app.toolbar
    },
    posLeft() {
      return 'left: calc(-1 * ' + this.ScrollLeft + 'px)'
    },
    ...mapGetters(["userInfo", 'token']),
    collegeName: {
      get() {
        return this.$store.state.user.userInfo.collegeName;
      },
    },
    lists: {
      get() {
        if (
          this.$store.state.user.userInfo &&
          this.$store.state.user.userInfo.extras
        ) {
          return this.$store.state.user.userInfo.extras.CollegeList || [];
        }
        return [];
      },
    },
    getCollegeId(){
      return this.$store.state.user.userInfo.collegeId
    }
  },
  async created() {
    this.getNav()
    if (!this.$route.query.parentId) {
      this.getCurrentSelected()
    } else {
      this.selected = this.$route.query.parentId
    }
    if (!this.selected) this.selected = 'index'
  },
  mounted() {
    this.$store.dispatch('getUnreadMessageCount')
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.screenRersize)

    window.addEventListener('load', () => {
      this.screenRersize()
    })
    // window.addEventListener("resize", this.handleResize)
    // this.handleResize()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.screenRersize)
  },

  watch: {
    $route(route, form) {
      this.isHome = route.name === 'Index'
      this.cleaerSearch()
      if (form.name === 'SampleBook' || form.name === 'bookDetail' || form.name === 'List') {
        if (route.query.parentId === 'list') {
          this.selected =  'list'
        } else if (route.query.parentId === 'index') {
          this.selected =  'index'
        }
      }
      EventBus.$on("deleteActiveMenu", data => {
        if (data) {
          this.selected =  ''
        }
      })
    }
  },
  methods: {
    switchSchool() {
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
      this.ruleForm.collegeId = "";
    },
    handleCommandCollege(command) {
      this.ruleForm.collegeId = command
      saveCollege(this.ruleForm).then((res) => {
        if (res.code === 200)
          this.$store.dispatch("GetInfo").then(() => {
            this.$router.replace({ path: "/redirect" + this.$route.fullPath });
          });
      });
    },
    jumpMessage() {
      this.selected =  ''
      this.$router.push({
        name: 'Message'
      })
    },
    openLogin() {
      this.$store.dispatch('openLogin', true)
    },
    goSearch(type = '0') {
      this.$router.push({
        name: 'Search',
        query: {
          time: new Date().getTime()
        },
        params: {
          searchVal: this.searchVal,
          type: type,
          routeName: type === '1' ? '高级搜索' : '搜索'
        }
      })
    },
    goToMy() {
      this.$router.push({
        name: 'my',
        query: {
          time: (new Date()).getTime()
        }
      })
    },
    handleCommand(command) {
      this[command]()
    },
    goToKeySearch(item) {
      this.$router.push({
        name: 'SearchResult',
        query: {
          browse: item.name,
          key: item.key
        }
      })
    },
    cleaerSearch() {
      this.showCover = false
      this.searchVal = ''
    },
    showBlogDetail() {
      this.selected = 'index'
      this.$router.push({
        name: 'Index'
      })
    },
    handleClickHome(item) {
      if (item.menuId === 'resourceCenter') {
        // 资源中心为外部站点，新开标签页以保留当前教材页面。
        window.open(process.env.VUE_APP_RESOURCE_FONTEND_URL, '_blank', 'noopener,noreferrer')
        return
      }
      // if (item.path === 'Index') {
      this.selected = item.menuId
      this.$router.push({
        name: item.path
      })
      // }
    },
    handleClick(item) {
      this.selected = item.parentId
      this.$router.push({
        path: item.path,
        query: {
          name: item.menuName,
        }
      })
    },
    getCurrentSelected() {
      if (this.$route.name === 'Booklist') {
        this.selected = 'booklist'
      } else if (this.$route.name === 'Textbook') {
        this.selected = 'textbook'
      } else if (this.$route.name === 'List') {
        this.selected = 'list'
      }
    },
    showSearchCover(flag = true) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      if (!flag) {
        this.timer = setTimeout(() => {
          this.showCover = false
        }, 500)
        return
      }
      this.showCover = flag
    },
    //退出登录
    handelLogout() {
      this.$store.dispatch('LogOut', true).then((res) => {
        // if((document.getElementsByClassName('my-wrapper').length) || (document.getElementsByClassName('textbook-report').length)) {
        //   window.location.href = window.location.origin + '/index';
        // } else {
        //   window.location.reload()
        // }
        if (process.env.VUE_APP_SSO_LOGIN == '1') {
          window.location.href = `${process.env.VUE_APP_BASE_API}/oauth2/sso/logout?returnUrl=${location.origin}/index`;
        } else {
          location.href = "/index";
        }
      })
    },
    getNav() {
      getNavMenu().then((res) => {
        const parentList = []
        const children = []
        res.data.forEach((el) => {
          el.show = false
          el.parentId === 0 ? parentList.push(el) : children.push(el)
        })
        children.forEach((el) => {
          parentList.some((item) => {
            if (item.menuId === el.parentId) {
              item.children.push(el)
              return true
            }
            return false
          })
        })
        // this.list = parentList.splice(0, 5)
        this.list = [
          {
            menuName: '教材',
            path: 'Textbook',
            menuId: 'textbook',
            show: false,
            //children: this.hierarchicalList
          },
          {
            menuName: '资源中心',
            menuId: 'resourceCenter',
            show: false
          },
          // {
          //   menuName: '书单',
          //   path: 'Booklist',
          //   menuId: 'booklist',
          //   show: false
          // },
          {
            menuName: '书架',
            path: 'List',
            menuId: 'list',
            show: false
          }
        ]
        this.list.unshift({
          menuName: '首页',
          path: 'Index',
          menuId: 'index',
          show: false
        })
        this.$store.dispatch('setNavMemu', res.data)
      })
    },
    itemStyle(item) {
      if (this.showCover) return 'color: #000'
      if (item.menuId === this.selected) {
        if (item.path !== 'Index' || !this.isHome || this.ScrollTop >= this.videoHeight) return ''
        else return 'background-color: rgba(255,255,255,0.8)'
      }
      return ''
    },
    handleScroll: debounce(function () {
      this.ScrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
    }, 100),
    screenRersize() {
      const height = document.querySelector('.frame')?.offsetHeight
      this.videoHeight = height - 78
    },
    goDownload() {
      this.$router.push('/download')
    }
  },
  beforeDestroy() {
    EventBus.$off('deleteActiveMenu')
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;

  font-weight: 400;
  color: #3e4d71;
  padding-bottom: 16px;
  display: block;
}
::v-deep .customer .el-dialog__header {
  line-height: 60px;
  border-bottom: 1px solid var(--lineColor);
  > span {
    font-size: 16px;

    font-weight: 600;
    color: #3e4d71;
  }
}
::v-deep .el-dialog.customer {
  border-radius: 4px;
}
::v-deep .customer .el-dialog__body {
  padding: 50px 94px;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  // border-bottom: 2px solid #fff;
  .container {
    height: 64px;
    max-width: 100%;
    min-width: 1200px;
    line-height: 64px;
    border-bottom: 1px solid #e8e8e8;
    .container-limit {
      user-select: none;
      height: 100%;
      display: flex;
      margin: auto;
      width: 1200px;
    }
    ul {
      align-items: center;
      padding-left: 0;
      // width: 57%;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #333;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      .circle {
        // width: 40px;
        // height: 40px;
        // border-radius: 20px;
        // border: 1px solid #fff;
        // display: inline-block;
        // background: #979797;
        // margin-bottom: -10px;
        // margin-right: 8px;
        display: inline-block;
        // max-width: 158px;
        height: 49px;
        // background: url('../../assets/images/logo.svg');
        background-size: contain;
        vertical-align: middle;
        line-height: 24px;
        margin-right: 16px;
      }
      .logo {
        cursor: pointer;
        user-select: none;
        display: flex;
        justify-content: center;
        margin-right: 43px;
      }
      .logo-text {
        .top {
          white-space: nowrap;
          font-family: PingFangSC-Medium;
          font-size: 24px;
          color: #333;
          line-height: 36px;
          letter-spacing: 0;
          font-weight: 500;
        }
      }
      li:not(.logo) {
        position: relative;
        // min-width: 60px;
        text-align: center;
        &:hover {
          color: var(--color);
          background-color: rgba(255, 255, 255, 0.6);
          cursor: pointer;
          &::before {
            content: '';
            display: block;
            position: absolute;
            bottom: 0px;
            left: 0;
            width: 100%;
            height: 4px;
            background: var(--color);
          }
        }
      }
      .selected {
        color: var(--color);
        font-weight: 600;
        &::before {
          content: '';
          display: block;
          position: absolute;
          bottom: 0px;
          left: 0;
          font-weight: 400;
          // height: 2px;
          // width: fill-available;
          // background: #1441ae;
          width: 100%;
          height: 4px;
          background: var(--color);
        }
      }
      .menu {
        position: relative;
        // width: 120px;
        padding: 0 20px;
        margin: 0 5px;
        white-space: nowrap;
        .menu-item {
          position: absolute;
          top: 65px;
          left: 0px;
          width: fit-content;
          white-space: nowrap;
          background: #fff;
          line-height: 45px;
          box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.1);
          color: #000;
          // text-align: left;
          // padding-left: 20px;
          font-weight: 400;
          padding: 10px 0;
          cursor: pointer;
          > div:hover {
            color: var(--color);
            background: rgba(18, 161, 130, 0.1);
            font-weight: 500;
          }
        }
      }
    }
    .home-ul {
      color: #fff;
    }
    .avatar {
      width: 35%;
      display: inline-flex;
      justify-content: flex-end;
      align-items: center;
      .circle {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        border: 1px solid #fff;
        display: inline-block;
        background: #979797;
      }
      .name {
        display: inline-block;
        margin-left: 12px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
      }
    }
    .search {
      // width: 20%;
      flex: 1;
      display: inline-flex;
      justify-content: right;
      align-items: center;
      .down-btn {
        width: 126px;
        height: 38px;
        color: black;
        border: 1px solid #ececec;
        border-radius: 18px;
        margin-right: 26px;
        font-weight: 400;
        padding: 0;
      }
      .home-btn {
        color: white;
        border: 1px solid white;
      }
      .search-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url('../../assets/images/search.svg');
        background-size: contain;
        cursor: pointer;
      }
      .home-icon {
        background: url('../../assets/images/search-home.svg');
      }
      .notice-box {
        position: relative;
        height: 80px;
        line-height: 80px;
        .count {
          position: absolute;
          top: 32px;
          right: -10px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          font-size: 10px;
          color: #fff;
          background: #fc4647;
          border-radius: 50%;
          transform: scale(0.8);
        }
      }
      .icon-top-notice {
        font-size: 24px;
        cursor: pointer;
        color: #333;
        margin-left: 15px;
      }
      .notice-icon {
        color: #fff;
      }
      .isLogin {
        display: flex;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
        }
        i {
          position: absolute;
          top: 25px;
          right: 0;
          background: none;
          margin-right: 0 !important;
        }
        .login-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 120px;
          position: relative;
          padding-right: 16px;
        }
      }
    }
    .login-btns,
    .isLogin {
      margin-left: 26px;
      span {
        cursor: pointer;
      }
    }
    .home-btns {
      color: white;
    }
  }
  .isFilter {
    backdrop-filter: blur(10px);
    &.container.transparent-header {
      backdrop-filter: blur(0);
      background: #fff;
      border-bottom: 1px solid #e8e8e8;
      .down-btn {
        border: 1px solid #ECECEC;
      }
      .el-dropdown-link {
        border: 1px solid #ECECEC;
      }
    }
  }
  .container-home {
    border-bottom: 1px solid rgba(238, 238, 238, 0.5);
    // .circle {
    //   background: url('../../assets/images/logo_home.svg') !important;
    // }
    .top,
    .bottom {
      color: white !important;
    }
    span {
      color: white;
    }
  }
  .container:not(.container-home) {
    background: white;
  }
  .container.transparent-header {
    background: transparent;
    border-bottom: 1px solid rgba(255, 255, 255, .5);
    .down-btn {
      border: 1px solid #3E4D71;
    }
    .el-dropdown-link {
      border: 1px solid #3E4D71;
    }
  }
  .sarch-cover {
    position: absolute;
    padding-top: 70px;
    left: 0;
    overflow: hidden;
    background: #fff;
    height: 222px;
    width: 100%;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    z-index: 1;
    .search {
      position: relative;
      max-width: 1200px;
      margin: auto;
      background: #fff;
      width: 100%;
    }
    i {
      position: absolute;
      // left: 564px;
      // top: 12px;
      // background: url('../../assets/images/search-icon.svg');
      background-size: contain;
      width: 24px;
      height: 24px;
      display: inline-block;
      cursor: pointer;
    }
    .input-with-select {
      width: 600px;
      height: 48px;
      float: left;
      outline: #fff;
      background: #eeeeee;
      // border: 3px solid rgba(255, 255, 255, 0.15);
      border-radius: 24px;
      ::v-deep .el-input__inner {
        border-radius: 24px;
        height: 100%;
        width: 100%;
        background: #eeeeee;
        border: 0;
        &:focus {
          border: 0;
        }
        &::placeholder {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #999999;
          letter-spacing: 0;
          text-align: justify;
          font-weight: 400;
        }
      }
      ::v-deep .el-input__icon {
        color: #999999;
        font-size: 25px;
      }
      ::v-deep .el-select {
        width: 120px;
      }
      ::v-deep .el-input__clear {
        color: #cccccc;
      }
      ::v-deep .el-input__suffix {
        right: 12px;
      }
    }
    .senior-search {
      position: absolute;
      cursor: pointer;
      left: 630px;
      top: 15px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #000000;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
    }
    .condition {
      position: absolute;
      left: 0;
      top: 48px;
      label {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        text-align: justify;
        font-weight: 400;
      }
      ul {
        display: inline-flex;
        margin-left: -30px;
        margin-top: 1em;
        li {
          margin-left: 24px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          text-align: justify;
          font-weight: 400;
          &:hover {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: var(--color);
            letter-spacing: 0;
            text-align: justify;
            font-weight: 400;
            border-bottom: 1px solid var(--color);
            cursor: pointer;
          }
        }
      }
    }
  }
}
.el-dropdown-link {
  max-width: 200px;
  //display: inline-block;
  font-size: 14px;
  color: #333;
  font-weight: 500 !important;
  cursor: pointer;
  // height: 28px;
  line-height: 36px;
  border: 1px solid #ececec;
  border-radius: 36px;
  padding: 0 15px;
  font-weight: 500;
  margin-right: 10px;
  display: flex;
  align-items: center;

  .college-name {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  // &:hover {
  //   background-color: rgba(238, 243, 255, 0.5);
  // }
  // &:active {
  //   background-color: rgba(238, 243, 255, 1);
  // }
}
</style>
<style lang="scss">
.collage-dropdown.el-dropdown-menu--medium {
  padding: 8px;
  width: 268px;
  max-height: 210px;
  background: #fff;
  box-shadow: 0px 5px 5px 0px rgba(0,0,0,0.1), 0px 8px 10px 0px rgba(0,0,0,0.06), 0px 3px 14px 0px rgba(0,0,0,0.05);
  border-radius: 4px;
  border: 1px solid #EAEAEA;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: 0px !important;
  .el-dropdown-menu__item {
    font-size: 14px;
    color: #3E4D71;
    line-height: 16px;
    text-align: left;
    padding: 8px 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    &:hover {
      background: #EEF3FF!important;
      color: #3E4D71!important;
    }
    &:active {
      background: #DDE6FE!important;
      color: #5584FB!important;
    }
    .collage-dropdown-menu__collegename {
      flex: 1;
      word-wrap: break-word; /* 旧版浏览器支持 */
      overflow-wrap: break-word; /* 标准属性 */
      word-break: break-all;
      margin-right: 5px;
    }
  }
  .popper__arrow {
    display: none;
  }
  // .collage-dropdown-menu__item {
  //   color: red;
  // }
}
</style>
